(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var form = overlay.querySelector('[data-search-form]');
  var spinner = overlay.querySelector('[data-search-spinner]');
  var clearBtn = overlay.querySelector('[data-search-clear]');
  var popular = overlay.querySelector('[data-search-popular]');
  var popularList = overlay.querySelector('[data-search-popular-list]');
  var results = overlay.querySelector('[data-search-results]');
  var collectionsEl = overlay.querySelector('[data-search-collections]');
  var collectionsSection = overlay.querySelector('[data-search-collections-section]');
  var queriesEl = overlay.querySelector('[data-search-queries]');
  var pagesEl = overlay.querySelector('[data-search-pages]');
  var productsEl = overlay.querySelector('[data-search-products]');
  var queriesSection = overlay.querySelector('[data-search-queries-section]');
  var pagesSection = overlay.querySelector('[data-search-pages-section]');
  var productsSection = overlay.querySelector('[data-search-products-section]');
  var noResultsEl = overlay.querySelector('[data-search-noresults]');
  var footerEl = overlay.querySelector('[data-search-footer]');
  var footerTerm = overlay.querySelector('[data-search-footer-term]');
  var openers = document.querySelectorAll('[data-open-search]');
  var closers = overlay.querySelectorAll('[data-close-search]');
  var debounceId = null;
  var lastQuery = '';

  // Parse embedded popular-items JSON. Collection thumbnails come from the
  // predictive search API (source of truth); do NOT mirror them in Liquid.
  var popularItems = [];
  try {
    var pitemsEl = overlay.querySelector('[data-search-popular-items]');
    if (pitemsEl && pitemsEl.textContent) popularItems = JSON.parse(pitemsEl.textContent) || [];
  } catch (_) { popularItems = []; }

  function open() {
    if (window.SC && window.SC.bodyLock && !overlay.classList.contains('is-open')) window.SC.bodyLock.lock();
    overlay.hidden = false;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { input && input.focus(); }, 60);
  }
  function close() {
    if (window.SC && window.SC.bodyLock && overlay.classList.contains('is-open')) window.SC.bodyLock.unlock();
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    if (input) input.value = '';
    if (clearBtn) clearBtn.hidden = true;
    resetResults();
  }
  function resetResults() {
    lastQuery = '';
    if (results) results.hidden = true;
    if (popular) popular.hidden = false;
    if (spinner) spinner.hidden = true;
    if (queriesEl) queriesEl.innerHTML = '';
    if (pagesEl) pagesEl.innerHTML = '';
    if (productsEl) productsEl.innerHTML = '';
    if (collectionsEl) collectionsEl.innerHTML = '';
    if (collectionsSection) collectionsSection.hidden = true;
    if (queriesSection) queriesSection.hidden = true;
    if (pagesSection) pagesSection.hidden = true;
    if (productsSection) productsSection.hidden = true;
    if (noResultsEl) { noResultsEl.hidden = true; noResultsEl.textContent = ''; }
    if (footerEl) footerEl.hidden = true;
  }
  function resetResultsKeepFocus() {
    if (results) results.hidden = true;
    if (popular) popular.hidden = false;
    if (spinner) spinner.hidden = true;
    if (queriesEl) queriesEl.innerHTML = '';
    if (pagesEl) pagesEl.innerHTML = '';
    if (productsEl) productsEl.innerHTML = '';
    if (collectionsEl) collectionsEl.innerHTML = '';
    if (collectionsSection) collectionsSection.hidden = true;
    if (queriesSection) queriesSection.hidden = true;
    if (pagesSection) pagesSection.hidden = true;
    if (productsSection) productsSection.hidden = true;
    if (noResultsEl) { noResultsEl.hidden = true; noResultsEl.textContent = ''; }
    if (footerEl) footerEl.hidden = true;
  }

  // /search/suggest.json returns price as a string already in units (e.g. "59.90").
  // Do NOT divide by 100. Strip any non-numeric characters (currency symbols) before parsing.
  function toUnits(v) {
    if (v == null) return NaN;
    if (typeof v === 'number') return v;
    var s = String(v).replace(/[^\d,.\-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }
  function money(amount, currency) {
    var n = toUnits(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(n);
    } catch (_) { return 'R$ ' + n.toFixed(2).replace('.', ','); }
  }
  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderPopular() {
    if (!popularList) return;
    popularList.innerHTML = popularItems.map(function (item) {
      var label = item && item.label ? item.label : '';
      if (!label) return '';
      return '<li><button type="button" class="search-overlay__popular-chip search-overlay__popular-chip--text" data-search-term="' + escapeHTML(label) + '">'
        + escapeHTML(label) + '</button></li>';
    }).join('');
  }
  renderPopular();

  function render(data, q) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var searchUrl = root + 'search';
    if (popular) popular.hidden = true;
    if (results) results.hidden = false;
    var res = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = (res.products || []).filter(function (p) { return p.available !== false; });
    var queries = res.queries || [];
    var collections = res.collections || [];
    var pages = res.pages || [];
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';

    // Categorias (com thumbnail)
    if (collections.length) {
      collectionsEl.innerHTML = collections.slice(0, 6).map(function (c) {
        var href = c.url || (root + 'collections/' + c.handle);
        // Predictive API returns `featured_image` on the collection resource.
        var imgUrl = (c.featured_image && c.featured_image.url)
          || (c.image && c.image.url)
          || '';
        if (!imgUrl) {
          // No image: render title only. Never draw an empty bordered box.
          return '<li><a href="' + href + '" class="no-thumb"><span class="title">' + escapeHTML(c.title) + '</span></a></li>';
        }
        return '<li><a href="' + href + '">'
          + '<span class="thumb"><img src="' + escapeHTML(imgUrl) + '" alt="' + escapeHTML(c.title) + '" loading="lazy" width="44" height="44"></span>'
          + '<span class="title">' + escapeHTML(c.title) + '</span></a></li>';
      }).join('');
      if (collectionsSection) collectionsSection.hidden = false;
    } else {
      collectionsEl.innerHTML = '';
      if (collectionsSection) collectionsSection.hidden = true;
    }

    // Sugestões
    if (queries.length) {
      queriesEl.innerHTML = queries.slice(0, 6).map(function (qi) {
        var text = qi.text || qi;
        return '<li><button type="button" data-search-term="' + escapeHTML(text) + '">' + (qi.styled_text || escapeHTML(text)) + '</button></li>';
      }).join('');
      if (queriesSection) queriesSection.hidden = false;
    } else {
      queriesEl.innerHTML = '';
      if (queriesSection) queriesSection.hidden = true;
    }

    // Páginas (coleções + pages)
    var pageItems = pages.map(function (pg) {
      var href = pg.url || (root + 'pages/' + pg.handle);
      return '<li><a href="' + href + '">' + escapeHTML(pg.title) + '</a></li>';
    });
    if (pageItems.length) {
      pagesEl.innerHTML = pageItems.slice(0, 6).join('');
      if (pagesSection) pagesSection.hidden = false;
    } else {
      pagesEl.innerHTML = '';
      if (pagesSection) pagesSection.hidden = true;
    }

    // Produtos (linhas horizontais)
    if (!products.length) {
      productsEl.innerHTML = '';
      if (productsSection) productsSection.hidden = true;
    } else {
      if (productsSection) productsSection.hidden = false;
      productsEl.innerHTML = products.slice(0, 5).map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<div class="media"><img src="' + p.featured_image.url + '" alt="' + escapeHTML(p.title) + '" loading="lazy"></div>'
          : '<div class="media"></div>';
        var priceNum = toUnits(p.price);
        var priceCurrent = !isNaN(priceNum) ? '<span class="price-current">' + money(priceNum, currency) + '</span>' : '';
        var compareRaw = (p.compare_at_price_max != null) ? p.compare_at_price_max
                        : (p.compare_at_price_min != null) ? p.compare_at_price_min
                        : (p.compare_at_price != null) ? p.compare_at_price : null;
        var compareNum = toUnits(compareRaw);
        var priceCompare = (!isNaN(compareNum) && !isNaN(priceNum) && compareNum > priceNum)
          ? '<span class="price-compare">' + money(compareNum, currency) + '</span>' : '';
        return '<li><a href="' + p.url + '">' + img
          + '<div class="info"><p class="title">' + escapeHTML(p.title) + '</p>'
          + '<div class="prices" data-coupon-product="' + escapeHTML(p.handle || '') + '">' + priceCompare + priceCurrent + '</div></div></a></li>';
      }).join('');
    }

    // Estado sem resultados
    var hasAny = collections.length || queries.length || pageItems.length || products.length;
    if (!hasAny) {
      if (results) results.hidden = true;
      if (noResultsEl) { noResultsEl.textContent = 'Nenhum resultado para “' + q + '”'; noResultsEl.hidden = false; }
      if (popular) popular.hidden = false;
    } else {
      if (noResultsEl) { noResultsEl.hidden = true; noResultsEl.textContent = ''; }
    }

    // Rodapé (sempre visível quando há um termo)
    if (footerEl) {
      footerEl.hidden = false;
      footerEl.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      if (footerTerm) footerTerm.textContent = '“' + q + '”';
    }
  }

  function fetchPredictive(q) {
    if (spinner) spinner.hidden = false;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,query,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (q !== lastQuery) return;
        render(data, q);
      })
      .catch(function () { resetResultsKeepFocus(); })
      .then(function () { if (spinner) spinner.hidden = true; });
  }

  function submit() {
    var q = (input.value || '').trim();
    if (!q) return;
    close();
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target) return;
    var opener = target.closest('[data-open-search]');
    if (opener) { e.preventDefault(); open(); return; }
    var closer = target.closest('[data-close-search]');
    if (closer && overlay.contains(closer)) { e.preventDefault(); close(); return; }
    var term = target.closest('[data-search-term]');
    if (term && overlay.contains(term)) {
      e.preventDefault();
      if (!input) return;
      input.value = term.getAttribute('data-search-term') || '';
      submit();
      return;
    }
    var clear = target.closest('[data-search-clear]');
    if (clear && overlay.contains(clear)) {
      e.preventDefault();
      if (!input) return;
      input.value = '';
      clearBtn.hidden = true;
      lastQuery = '';
      resetResultsKeepFocus();
      input.focus();
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQuery = q;
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (debounceId) clearTimeout(debounceId);
      if (q.length < 2) { resetResultsKeepFocus(); return; }
      debounceId = setTimeout(function () { fetchPredictive(q); }, 250);
    });
  }
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    e.preventDefault();
    submit();
  }, true);
})();
